import { Grid } from '@mui/material';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  createGetDepartmentDefaultLabelsOptions,
  updateDepartmentWorker,
} from '../../queries/departmentQueries';
import { sendEmail } from '../../queries/emailQueries';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  boldFont,
  buttonDiv,
  LocalSiteDropdown,
  popupInformationGrid,
} from '../../styles';
import { isEmptyObject } from '../../utils';
import Button from '../atoms/button';
import CustomSelect from '../atoms/custom-select';

const SingleValuePopup = props => {
  const { defaultPopupData, popupData, departmentName, siteId } = props;
  const userInfo = useSelector(state => state.userInfo);
  const defaultName = defaultPopupData?.map(item => {
    return { label: `${item.FirstName} ${item.LastName}`, value: item.ID };
  });

  const options = popupData?.map(worker => {
    return {
      label: `${worker.FirstName} ${worker.LastName}`,
      value: worker.ID,
      Email: worker.Email,
    };
  });
  const [optionChange, setOptionChange] = useState(defaultName);
  const [apiData, setApiData] = useState({});
  const [assigneeEmail, setAssigneeEmail] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { mutate } = useMutation({
    mutationFn: updateDepartmentWorker,
    onSuccess: () => {
      props.handleClose();
      navigate('/List');
    },
    onError: error => {
      console.error('Error updating department worker:', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });
  const { mutate: sendAssignmentEmail } = useMutation({
    mutationFn: sendEmail,
    onError: error => {
      console.error('Error sending cancel email:', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });
  const { data: departmentNames, error } = useQuery(
    createGetDepartmentDefaultLabelsOptions({
      departmentName,
      siteId,
    })
  );
  if (error) {
    dispatch(
      errorNotification({
        hasErrorOccured: true,
        message: t('error_message'),
      })
    );
  }

  const handleChange = option => {
    setOptionChange(option);
    setAssigneeEmail(option.Email);
    if (popupData.length > 0 && departmentName === 'Compliance') {
      setApiData({
        compliance: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'EH&S') {
      setApiData({
        ehs: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Finance') {
      setApiData({
        finance: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Aftermarket') {
      setApiData({
        aftermarket: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Literature') {
      setApiData({
        literature: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Marketing') {
      setApiData({
        marketing: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Purchasing') {
      setApiData({
        purchasing: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Safety Committee') {
      setApiData({
        safetycommittee: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Master Data') {
      setApiData({
        masterdata: option ? option.value : '',
      });
    } else if (popupData.length > 0 && departmentName === 'Sales Tools') {
      setApiData({
        salestools: option ? option.value : '',
      });
    } else if (
      popupData.length > 0 &&
      (departmentName === 'Engineering' ||
        departmentName === 'Quality' ||
        departmentName === 'Manufacturing' ||
        departmentName === 'Sales')
    ) {
      const departmentLabel = getSubDepartmentLabel(props.subDepartment);
      setApiData({
        [departmentLabel]: option ? option.value : '',
      });
    } else if (
      popupData.length > 0 &&
      departmentName === 'Logistics / Supply Chain'
    ) {
      const departmentLabel = getLogisticsSupplyChainLabel(props.subDepartment);
      setApiData({
        [departmentLabel]: option ? option.value : '',
      });
    } else if (
      popupData.length > 0 &&
      departmentName === 'Industrial Process'
    ) {
      const departmentLabel = getIndustrialProcessLabel(props.subDepartment);
      setApiData({
        [departmentLabel]: option ? option.value : '',
      });
    }
  };
  function getIndustrialProcessLabel(label) {
    if (departmentNames && departmentNames.length > 0) {
      const department = departmentNames.find(
        dept => dept.SubDepartmentName === label
      );

      return Number(department.DepartmentID) === 1
        ? 'industrialprocess'
        : `industrialprocess${department.DepartmentID}`;
    }
  }
  function getLogisticsSupplyChainLabel(label) {
    if (departmentNames && departmentNames.length > 0) {
      const department = departmentNames.find(
        dept => dept.SubDepartmentName === label
      );

      return Number(department.DepartmentID) === 1
        ? 'logistics'
        : `logistics${department.DepartmentID}`;
    }
  }
  function getSubDepartmentLabel(label) {
    if (departmentNames && departmentNames.length > 0) {
      const department = departmentNames.find(
        dept => dept.SubDepartmentName === label
      );

      return `${department.DepartmentName.toLowerCase()}${department.DepartmentID}`;
    }
  }
  const onPopupSaveClick = () => {
    if (isEmptyObject(apiData)) {
      props.handleClose();
      // setToggleSavePopupClick(!toggleSavePopupClick);
    } else {
      mutate({
        ...apiData,
        pecrId: props.pecrId,
        siteId: props.siteId,
        DepartmentID: props.departmentId,
        UpdatedByUserID: props.updatedBy,
        siteCoordinator: props.siteCoordinator,
        owner: props.siteOwner,
      });
      sendAssignmentEmail({
        toWhome: 'BackUp Site Coordinator',
        PecrId: props.pecrId,
        role: 'Department Lead',
        toAddress: assigneeEmail,
        fromAddress: 'PECR@carrier.com',
        loginUserEmail: userInfo.userEmail,
        Title: `You have been assigned a task on PECR: ${props.pecrId}`,
        type: 'assignEmail',
        summaryURL: `${window.location.origin}/TrackingFile?id=${props.pecrId}`,
        URL: `${window.location.origin}/undefined3/1`,
      });
    }
  };

  return (
    <Grid>
      <Grid style={popupInformationGrid}>
        <Grid style={boldFont}>{`${t('Owner')}:`}</Grid>
        <Grid style={LocalSiteDropdown}>
          <CustomSelect
            name={'departmentowner'}
            id={'departmentowner'}
            placeholder={t('Select_Department_Owner')}
            options={options.length > 0 ? options : []}
            onChange={handleChange}
            value={optionChange}
            isClearable={true}
          />
        </Grid>
      </Grid>
      <Grid style={buttonDiv}>
        <Button title={t('Cancel')} onClick={props.handleClose} />
        <Button title={t('Save')} onClick={onPopupSaveClick} />
      </Grid>
    </Grid>
  );
};
export default SingleValuePopup;
